module.exports = __webpack_public_path__ + "static/img/bn1.22ff8b6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/bn1.gif
// module id = uyCs
// module chunks = 1